__turbopack_context__.v({
  "volumeIcons": "gPzOYa_volumeIcons",
  "volumeSlider": "gPzOYa_volumeSlider",
  "volumeSliderContainer": "gPzOYa_volumeSliderContainer",
  "volumeSliderContainerOpen": "gPzOYa_volumeSliderContainerOpen",
});
